import {Node} from "@xyflow/react";

export function getCenterXFromNodes(nodes: Node[]) {
    if (nodes.length === 0) return 0;
    return nodes.map(n => n.position.x ?? 0).reduce((a, b) => a + b, 0) / nodes.length;
}
